<template>
  <div class="login">
    <div class="page-wrapper pa-0 ma-0 auth-page">
      <div class="container-fluid">
        <!-- Row -->
        <div>
          <div class="auth-form-wrap">
            <div class="auth-form ml-auto mr-auto no-float">
              <div class="row">
                <div class="col-sm-12 col-xs-12">
                  <div class="mb-30">
                    <h3 class="text-center txt-dark mb-10">Sign in to Nutrivitas</h3>
                    <h6 class="text-center nonecase-font txt-grey">Enter your details below</h6>
                  </div>
                  <div class="form-wrap">
                    <form class="form-signin" @submit.prevent="login" v-if="!registerMode && !forgotPasswordMode">
                      <div class="form-group">
                        <label class="control-label mb-10" for="inputEmail">Email address</label>
                        <input
                          type="email"
                          v-model="email"
                          id="inputEmail"
                          class="form-control"
                          placeholder="Email address"
                          required
                          autofocus
                        >
                      </div>
                      <div class="form-group">
                        <label
                          class="pull-left control-label mb-10"
                          for="exampleInputpwd_2"
                        >Password</label>
                        <input
                          type="password"
                          v-model="password"
                          id="inputPassword"
                          class="form-control"
                          placeholder="Password"
                          required
                        >
                      </div>

                      <div class="form-group text-center">
                        <button type="submit" class="btn btn-success btn-rounded">sign in</button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <fb-signin-button
                          class="btn btn-rounded btn-facebook"
                          :params="fbSignInParams"
                          @success="onSignInSuccess"
                          @error="onSignInError"
                        >Sign in with Facebook</fb-signin-button>
                      </div>
                      <div class="text-center">
                        <a class="link"
                           href="javascript:void(0)"
                           @click="registerMode = true"
                        >Don't have an account? Register</a><br/>
                        <a class="link"
                           href="javascript:void(0)"
                           @click="forgotPasswordMode = true"
                        >Forgot Password?</a>
                      </div>
                    </form>

                    <form class="form-signin" @submit.prevent="resetPassword" v-if="forgotPasswordMode">
                      <div class="form-group">
                        <label class="control-label mb-10" for="inputEmail">Email address</label>
                        <input
                          type="email"
                          v-model="email"
                          id="inputEmail"
                          class="form-control"
                          placeholder="Email address"
                          required
                          autofocus
                        >
                      </div>

                      <div class="form-group text-center">
                        <button type="submit" class="btn btn-success btn-rounded">Reset Password</button>
                      </div>
                      <div class="text-center">
                        <a class="link"
                           href="javascript:void(0)"
                           @click="registerMode = true"
                        >Don't have an account? Register</a> <br/>
                        <a class="link"
                           href="javascript:void(0)"
                           @click="forgotPasswordMode = false"
                        >I Remember my password</a>
                      </div>
                    </form>

                    <form class="form-register" @submit.prevent="register" v-if="registerMode">
                      <div class="form-group">
                        <label class="control-label mb-10" for="name">Name & Surname</label>
                        <input
                          autocomplete="false"
                          type="text"
                          v-model="name"
                          id="name"
                          class="form-control"
                          placeholder="Name & Surname"
                          required
                          autofocus
                        >
                      </div>
                      <div class="form-group">
                        <label class="control-label mb-10" for="inputEmail">Email address</label>
                        <input
                          autocomplete="false"
                          type="email"
                          v-model="email"
                          id="inputEmail"
                          class="form-control"
                          placeholder="Email address"
                          required
                        >
                      </div>
                      <div class="form-group">
                        <label
                          class="pull-left control-label mb-10"
                          for="exampleInputpwd_2"
                        >Password</label>
                        <input
                          autocomplete="false"
                          type="password"
                          v-model="password"
                          id="inputPassword"
                          class="form-control"
                          placeholder="Password"
                          required
                        >
                      </div>
                      <div class="form-group">
                        <input
                          name="tnc"
                          autocomplete="false"
                          type="checkbox"
                          v-model="tnc_agreed"
                        > I have read and agree with the <a href="http://nutrivitas.com/terms-and-conditions/" target="_blank">terms and conditions</a>
                      </div>
                      <div class="form-group text-center" v-if="tnc_agreed">
                        <button type="submit" class="btn btn-success btn-rounded">Register</button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <fb-signin-button
                          class="btn btn-rounded btn-facebook"
                          :params="fbSignInParams"
                          @success="onSignInSuccess"
                          @error="onSignInError"
                        >Register with Facebook</fb-signin-button>
                      </div>
                      <div class="text-center">
                         <a class="link"
                           href="javascript:void(0)"
                           @click="registerMode = false"
                           v-if="registerMode"
                        >Already have an account? Sign in</a>
                      </div>
                    </form>
                    <div id="status" :class="statusClass">{{status}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Row -->
      </div>
    </div>
    <!-- /Main Content -->
  </div>
</template>

<script>
import API from "../../services/api.js";
import { mapMutations } from "vuex";
const api = new API();

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      status: null,
      statusClass: null,
      loggedIn: false,
      tnc_agreed: false,
      fbSignInParams: {
        scope: "email",
        return_scopes: true
      },
      registerMode: false,
      forgotPasswordMode: false,
    };
  },
  created() {
    this.$store.commit("resetStore");
  },
  methods: {
    onSignInSuccess(response) {
      FB.api("/me?fields=email,name,picture.width(300).height(300)", user => {
        api.fbLogin(user).then(response => {
          if (response.data.success) {
            this.redirectAfterLogin(response);
          } else {
            this.showStatus("danger", response.data.message);
          }
        });
      });
    },
    onSignInError(error) {
      console.log("OH NOES", error);
    },
    resetPassword() {
      this.showStatus("info", "Sending Password Email");
      api.resetPassword(this.email).then(response => {
          if (response.data.success) {
            this.showStatus("info", "We sent an email to your email address for you to reset your password.");     
          } else {
            this.showStatus("danger", response.data.message);
          }
        })
        .catch(e => {
          this.showStatus("danger", "An error has occured");
        });
    },
    login() {
      //Login using email and password
      this.showStatus("info", "Logging in...");
      api
        .login(this.email, this.password)
        .then(response => {
          if (response.data.success) {
            let date = new Date().getFullYear() + "-" + pad((new Date().getMonth() + 1), 2) + "-" + pad(new Date().getDate(), 2);
            this.$store.commit('updateGlobalDate', date);
            this.redirectAfterLogin(response);
          } else {
            this.showStatus("danger", response.data.message);
          }
        })
        .catch(e => {
          this.showStatus("danger", "An error has occured");
        });
    },
    register() {
      //Register using email and password
      this.showStatus("info", "Registering new account...");
      api.register(this.name, this.email, this.password).then(response => {
        if (response.data.success) {
          this.showStatus("info", "Account successfully registered. Please check your email to confirm your account. When confirmed please come back and login.");
        } else {
          this.showStatus("danger", response.data.message);
        }
      });
    },
    showStatus(type, message) {
      this.statusClass = "alert-" + type;
      this.status = message;
    },
    redirectAfterLogin(response) {
      this.$store.commit("updateAPIToken", response.data.data.token);
      this.$store.commit("updateUser", response.data.data.user);
      this.showStatus("info", "Logged in. Redirecting...");

      if (this.$store.getters.user.meta_data.first_time_user) {
        this.navigate("/welcome");
      } else {
        this.navigate("/dashboard");
      }
    }
  }
};

function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
}
</script>

<style>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}

.auth-page{
   height: 100vh;
}

.login {
   background-image: url('https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/webapp/Login-BG.jpg');
   background-size: cover;
}

.page-wrapper.auth-page {
   background: transparent;
}

.auth-form-wrap {
   background: #ffffff;
   max-width: 600px;
   margin: 20px auto;
   border-radius: 5px;
}

.btn-facebook {
   color: #ffffff;
}
.link {
   font-size: 12px;
   color:teal;
}
</style>


// WEBPACK FOOTER //
// src/views/Login/Login.vue